import { goToBranchesOrderBy } from '../../dashboard.service';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';

export const breakdownDataBuilder = teamWorkBreakdownData => {
  const { newWork, refactor, rework, totalChanges } = teamWorkBreakdownData;
  return [
    {
      color: '#5CEB73',
      colorName: 'pastelGreen',
      name: 'New Work',
      percent: newWork,
      value: Math.round(totalChanges * (Number(newWork) / 100))
    },
    {
      color: '#4451BF',
      colorName: 'indigo',
      name: 'Refactor',
      percent: refactor,
      value: Math.round(totalChanges * (Number(refactor) / 100))
    },
    {
      color: '#AC98FF',
      colorName: 'melrose',
      name: 'Rework',
      percent: rework,
      value: Math.round(totalChanges * (Number(rework) / 100))
    }
  ];
};

export const onClickGoToActivity = (uiState, selectedTeam, history) => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.DASHBOARD,
    click_type: TRACKING.CLICK.WORK_BREAKDOWN_CONTEXT
  });
  goToBranchesOrderBy('code_changes,desc', uiState, selectedTeam, history);
};

export const onClickOpenWorkBreakdownTrend = (e, setAnchorEl, anchorEl) => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.DASHBOARD,
    click_type: TRACKING.CLICK.WORK_BREAKDOWN_TREND
  });
  setAnchorEl(anchorEl ? null : e.currentTarget);
};

export const emptyDataWorkBreakdown = [
  {
    color: '#EBEEF5',
    name: '',
    value: 20
  },
  {
    color: '#BDC1C6',
    name: '',
    value: 15
  },
  {
    color: '#C4CDE0',
    name: '',
    value: 5
  }
];
